module.exports = __webpack_public_path__ + "static/media/edge.a5b1304a.svg";